import Button from "@/components/Button";
import ErrorBoundary from "@/components/ErrorBoundary";
import CareerServicesDashboardSectionPicker from "./CareerServicesDashboardSectionPicker";
import { useCareerServicesDashboardSectionSelection } from "../_hooks/useCareerServicesDashboardSectionSelection";

export default function CareerServicesDashboardSectionFilter() {
  const { sections, sectionId, setSectionId, requiresSectionSelection, loading, error, retry } =
    useCareerServicesDashboardSectionSelection();

  if (error) {
    return (
      <div className="w-full max-w-sm" data-testid="career-services-dashboard-section-error">
        <ErrorBoundary
          title="Unable to load dashboard sections"
          message="Please try again."
          action={
            <Button variant="outlined" onClick={retry}>
              Try again
            </Button>
          }
          variant="inline"
        />
      </div>
    );
  }

  if (loading || (!requiresSectionSelection && sections.length <= 1)) {
    return null;
  }

  return (
    <div className="w-full max-w-sm" data-testid="career-services-dashboard-section-filter">
      <CareerServicesDashboardSectionPicker
        sections={sections}
        sectionId={sectionId}
        onSectionChange={setSectionId}
        selectionRequired={requiresSectionSelection}
      />
    </div>
  );
}
